import type { RegistryEntry, UiOptionNumber } from '../types';

const FLUX_SEED_OPTION = {
  key: 'seed',
  label: 'Seed',
  type: 'number',
  min: 0,
  max: 2147483647,
  step: 1,
  group: 'basic',
} as UiOptionNumber;

const toFluxProviderOptions = (ui: Record<string, any>) =>
  ({
    seed: typeof ui.seed === 'number' && Number.isFinite(ui.seed) ? ui.seed : undefined,
  }) as unknown as Record<string, Record<string, any>>;

const fluxSeedEntry: RegistryEntry = {
  options: [FLUX_SEED_OPTION],
  toProviderOptions: toFluxProviderOptions,
};

// Black Forest Labs (FLUX) 系列
export const fluxConfigs: Record<string, RegistryEntry> = {
  'flux-2-flex': fluxSeedEntry,
  'flux-2-max': fluxSeedEntry,
  'flux-2-pro': fluxSeedEntry,
  'flux-2-klein-9b': fluxSeedEntry,
  'flux-2-klein-4b': fluxSeedEntry,
};